import { IMicrosite } from "../app/models/microsite";

const isVisit = window.location.hostname.toLowerCase().includes("visit");

export const microsites: IMicrosite[] = [
  {
    name: "Logger",
    entrypoint: "/logger",
    host: isVisit
      ? "https://hhsconsole.fsp.visitstaging.org/ui/logger"
      : "https://console.hhs.intouchstaging.com/ui/logger",
    displayName: "Log Service",
  },
  {
    name: "Monitoring",
    entrypoint: "/monitoring",
    host: isVisit
      ? "https://hhsconsole.fsp.visitstaging.org/ui/monitoring"
      : "https://console.hhs.intouchstaging.com/ui/monitoring",
    displayName: "Monitoring",
  },
  {
    name: "Updater",
    entrypoint: "/updater",
    host: isVisit
      ? "https://hhsconsole.fsp.visitstaging.org/ui/updater"
      : "https://console.hhs.intouchstaging.com/ui/updater",
    displayName: "Updater",
  },
  {
    name: "DeviceProvisioning",
    entrypoint: "/provisioning",
    host: isVisit
      ? "https://hhsconsole.fsp.visitstaging.org/ui/provisioning"
      : "https://console.hhs.intouchstaging.com/ui/provisioning",
    displayName: "Device Provisioning",
  },
  {
    name: "AccessManagement",
    entrypoint: "/access",
    host: isVisit
      ? "https://hhsconsole.fsp.visitstaging.org/ui/access"
      : "https://console.hhs.intouchstaging.com/ui/access",
    displayName: "Access Management",
  },
  {
    name: "PASProvisioning",
    entrypoint: "/pas-provisioning",
    host: isVisit
      ? "https://hhsconsole.fsp.visitstaging.org/ui/pas-provisioning"
      : "https://console.hhs.intouchstaging.com/ui/pas-provisioning",
    displayName: "PAS Provisioning",
  },
  {
    name: "AuxUpdater",
    entrypoint: "/auxupdater",
    host: isVisit
      ? "https://hhsconsole.fsp.visitstaging.org/ui/auxupdater"
      : "https://console.hhs.intouchstaging.com/ui/auxupdater",
    displayName: "Aux Updater",
  },
  {
    name: "ITLLogViewer",
    entrypoint: "/itl-log-viewer",
    host: isVisit
      ? "https://hhsconsole.fsp.visitstaging.org/ui/itl-log-viewer"
      : "https://console.hhs.intouchstaging.com/ui/itl-log-viewer",
    displayName: "ITL Log Viewer",
  },
];
